import { AttributesMixin, define, Model } from "@type-r/models";
import { CommonParticipant } from "./commonParticipant";
import { getAuthorizationBearer, restfulIO } from "./endpoint";

export class CompanyParticipant extends Model {
    static attributes = {
        productCode: String,
        platformCode: String,
        roleName: String,
        companyId: Number,
        participantId: Number,
        companyName: String,
        salesforceId: String,
        taxId: String,
        duns: String
    }
}

export interface Buyer extends AttributesMixin<typeof Buyer> { }

@define
export class Buyer extends CompanyParticipant {
    static endpoint = restfulIO('api/v1/companyParticipants/buyers');
    static idAttribute = "companyId";

    static attributes = {
        ...CompanyParticipant.attributes
    }
}

export async function getBuyers(quicksearch?: string, companyId?: number): Promise<Buyer[]> {
    let parameters = [
        quicksearch ? `quicksearch=${quicksearch}` : '',
        companyId ? `companyId=${companyId}` : ''
    ];

    let urlParameters = parameters.some(s => s !== '') ? `?${parameters.filter(s => s !== '').join('&')}` : '';

    let url: string = `api/v1/companyParticipants/buyers/filter${urlParameters}`;
    return (await fetch(url, {
        method: 'GET',
        headers: new Headers({
            "Authorization": getAuthorizationBearer()
        }),
    })).json();
}

export interface Supplier extends AttributesMixin<typeof Supplier> { }

@define
export class Supplier extends CompanyParticipant {
    static endpoint = restfulIO('api/v1/companyParticipants/suppliers');
    static idAttribute = "companyId";

    static attributes = {
        ...CompanyParticipant.attributes
    }
}

export async function getSuppliers(quicksearch?: string, companyId?: number): Promise<Supplier[]> {
    let parameters = [
        quicksearch ? `quicksearch=${quicksearch}` : '',
        companyId ? `companyId=${companyId}` : ''
    ];

    let urlParameters = parameters.some(s => s !== '') ? `?${parameters.filter(s => s !== '').join('&')}` : '';

    let url: string = `api/v1/companyParticipants/suppliers/filter${urlParameters}`;
    return (await fetch(url, {
        method: 'GET',
        headers: new Headers({
            "Authorization": getAuthorizationBearer()
        }),
    })).json();
}

export const getSuppliersAsCommonParticipants = async (query) => {
    let items = await getSuppliers(query);

    let uniqueCompanies: CommonParticipant[] = [];

    if (items) {
        items.forEach(x => {
            if (!uniqueCompanies.some(y => y.companyId === x.companyId)) {
                uniqueCompanies.push({ id: x.participantId, companyId: x.companyId, name: x.companyName } as CommonParticipant);
            }
        });
    }
    return uniqueCompanies;
}

export const getBuyersAsCommonParticipants = async (query) => {
    let items = await getBuyers(query);

    let uniqueCompanies: CommonParticipant[] = [];

    if (items) {
        items.forEach(x => {
            if (!uniqueCompanies.some(y => y.companyId === x.companyId)) {
                uniqueCompanies.push({ id: x.participantId, companyId: x.companyId, name: x.companyName } as CommonParticipant);
            }
        });
    }
    return uniqueCompanies;
}

export interface Payor extends AttributesMixin<typeof Payor> { }

@define
export class Payor extends CompanyParticipant {
    static endpoint = restfulIO('api/v1/companyParticipants/payers');
    static idAttribute = "companyId";

    static attributes = {
        ...CompanyParticipant.attributes
    }
}

export async function getPayers(quicksearch?: string, companyId?: number): Promise<Payor[]> {
    let parameters = [
        quicksearch ? `quicksearch=${quicksearch}` : '',
        companyId ? `companyId=${companyId}` : ''
    ];

    let urlParameters = parameters.some(s => s !== '') ? `?${parameters.filter(s => s !== '').join('&')}` : '';

    let url: string = `api/v1/companyParticipants/payers/filter${urlParameters}`;
    return (await fetch(url, {
        method: 'GET',
        headers: new Headers({
            "Authorization": getAuthorizationBearer()
        }),
    })).json();
}

export const getPayersAsCommonParticipants = async (query) => {
    let items = await getPayers(query);

    let uniqueCompanies: CommonParticipant[] = [];

    if (items) {
        items.forEach(x => {
            if (!uniqueCompanies.some(y => y.companyId === x.companyId)) {
                uniqueCompanies.push({ id: x.participantId, companyId: x.companyId, name: x.companyName } as CommonParticipant);
            }
        });
    }
    return uniqueCompanies;
}

export interface Payee extends AttributesMixin<typeof Payee> { }

@define
export class Payee extends CompanyParticipant {
    static endpoint = restfulIO('api/v1/companyParticipants/payees');
    static idAttribute = "companyId";

    static attributes = {
        ...CompanyParticipant.attributes
    }
}

export async function getPayees(quicksearch?: string, companyId?: number): Promise<Payee[]> {
    let parameters = [
        quicksearch ? `quicksearch=${quicksearch}` : '',
        companyId ? `companyId=${companyId}` : ''
    ];

    let urlParameters = parameters.some(s => s !== '') ? `?${parameters.filter(s => s !== '').join('&')}` : '';

    let url: string = `api/v1/companyParticipants/payees/filter${urlParameters}`;
    return (await fetch(url, {
        method: 'GET',
        headers: new Headers({
            "Authorization": getAuthorizationBearer()
        }),
    })).json();
}

export const getPayeesAsCommonParticipants = async (query) => {
    let items = await getPayees(query);

    let uniqueCompanies: CommonParticipant[] = [];

    if (items) {
        items.forEach(x => {
            if (!uniqueCompanies.some(y => y.companyId === x.companyId)) {
                uniqueCompanies.push({ id: x.participantId, companyId: x.companyId, name: x.companyName } as CommonParticipant);
            }
        });
    }
    return uniqueCompanies;
}